/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const COMPANY_OWNER_CAN_ABILITY = [
  ['read', 'MyProfile'],
  ['read', 'OrganizationProfile'],
  ['read', 'Application'],
  ['read', 'DraftAppList'],
  ['read', 'NotFound'],
  ['read', 'ApplicationStatus'],
  ['read', 'SubmittedAppList'],
  ['read', 'RejectedAppList'],
  ['read', 'ApplicationDetail'],
  ['read', 'Payment'],
  ['read', 'OrgAdminList'],
  ['read', 'AllUserList'],
  ['read', 'UserProfile'],
  ['read', 'EmployeeList'],
  ['read', 'OrganizationAdmin'],

  ['read', 'PaymentSuccess'],
  ['read', 'PaymentFailure'],
  ['read', 'ApprovedApplication'],
  ['read', 'MissingInfo'],
  ['read', 'PendingPayment'],
  ['read', 'GenericReport'],
  ['read', 'MasterReport'],
  ['read', 'CredentialList'],
  ['read','PaymentTransaction']
];

export const COMPANY_OWNER_CANNOT_ABILITY = [['read', 'MasterAdminInvite']];
